import { render } from "./EuropeanQuantumEcosystem.vue?vue&type=template&id=1460aab2&scoped=true"
const script = {}

import "./EuropeanQuantumEcosystem.vue?vue&type=style&index=0&id=1460aab2&scoped=true&lang=css"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1460aab2"]])

export default __exports__